var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["z-hero", _vm.heroClass] }, [
    _c("div", { staticClass: "z-hero__container container container--wide" }, [
      _c("div", { staticClass: "z-hero__content" }, [
        !!this.$slots["breadcrumbs"]
          ? _c(
              "div",
              { staticClass: "z-hero__breadcrumbs hide-me--v-tablet" },
              [_vm._t("breadcrumbs")],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.titleShow
          ? _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-default-8 col-tablet-12" }, [
                _c(
                  "h1",
                  {
                    staticClass: "z-hero__title u-collapse--all",
                    class: _vm.heroTitle.length <= 50 ? "header-2" : "header-3",
                  },
                  [
                    _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.heroTitle) },
                    }),
                  ]
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        !!this.$slots["page-nav"]
          ? _c(
              "div",
              {
                staticClass:
                  "z-hero__page-nav hide-me--default show-me--tablet",
              },
              [_vm._t("page-nav")],
              2
            )
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c("div", {
      class: [
        "z-hero__bg",
        { "z-hero__bg--with-animation": _vm.animation },
        { "is-animated": _vm.animated },
      ],
      style: _vm.heroStyle,
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }